export const MOBILE_CHAT_DIALOG_TOP_GAP = 16;
export const MOBILE_CHAT_DIALOG_PANEL_CLASS = 'chat-dialog-mobile';
export const MOBILE_CHAT_DIALOG_HEIGHT = `calc(100% - ${MOBILE_CHAT_DIALOG_TOP_GAP}px - env(safe-area-inset-top))`;
